export enum Actions {
  ADD_EMPLOYEE,
  ADD_TEAM,
  ADD_VALUE,
  DELETE_TEAM,
  DELETE_VALUE,
  EDIT_MISSION_VISION_MANIFESTO,
  EDIT_ORGANIZATION_STRUCTURE,
  EDIT_TEAM,
  EDIT_VALUE,
  EDIT_BUSINESS_OUTCOMES,
  INVITE_ADMIN,
  INVITE_OWNER,
  INVITE_MANAGER,
  UPDATE_KUDO_VISIBILITY,
  UPDATE_ROLE_TO_ADMIN,
  UPDATE_ROLE_TO_MANAGER,
  UPDATE_ROLE_TO_MEMBER,
  UPDATE_ROLE_TO_OWNER,
  VIEW_COMPANY_SETTINGS,
  VIEW_CANDIDATE_CALIBRATION,
  VIEW_MANAGE_ASSESSMENTS,
  VIEW_MANAGE_DIRECTORY,
  VIEW_INTEGRATIONS,
  VIEW_ACTION_STEP_STATUS,
  VIEW_COMPANY_ACTION_STEPS,
  VIEW_BUSINESS_OUTCOMES,
  VIEW_DASHBOARD_STEPS,
  EDIT_COMPANY,
  SLACK_INTEGRATIONS,
  UPDATE_PLAN,
  VIEW_BILLING,
  EDIT_INSTILL_FLOW_SETTINGS,
  VIEW_CULTURE_KPI,
  MODIFY_CULTURE_KPI,
  PERFORM_PEOPLE_ACTION_ON_OWNER,
  PERFORM_PEOPLE_ACTION_ON_ADMIN,
  PERFORM_PEOPLE_ACTION_ON_MANAGER,
  PERFORM_PEOPLE_ACTION_ON_MEMBER,
  EDIT_MEETING_CLASSIFICATION_SETTINGS,
  CREATE_ASSESSMENT,
  SEND_TAKEAWAYS_EMAIL,
  VIEW_USER_CULTURE_CONTRIBUTION,
  VIEW_LEADERSHIP_SCORE,
  VIEW_MICRO_CULTURE_SCORE,
  VIEW_KEY_TRENDS_WIDGET,
  VIEW_COMPANY_KEY_TRENDS,
  SEND_VALUES_REMINDER,
  PERSONALITY_ASSESSMENT_REMINDER,
  VIEW_PRIVACY_PREFERENCES,
  MANAGE_ORGANIZATION_INTEGRATIONS,
}
